import React, { useState, useEffect } from "react";
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { Text1, Text4 } from "../../../styles";
import { EaseTable } from "../../../libs/EaseTable";
import { getRecordsTableColumns } from "./constants";
import { isMobile } from "react-device-detect";
import { handleApiExceptions } from "../../../app_methods";
import { BulkUploadBatch } from "../../../models";
import { RecordDetailsDrawer } from "./details_drawer";
import { Badge, Button, Tooltip, Select, Descriptions } from "antd";
import FileSaver from 'file-saver';
import { PermissionHoc } from '../../HOC';
import { PaginationKaBaap } from "../../Common";

const batch = new BulkUploadBatch();

const PermissableButton = PermissionHoc(Button, "BULK_OPERATIONS_EXPORT", { is_component: true, fallbackComponent: null })

const RecordsDrawer = (props) => {
    const [records, setRecords] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [showRecordDetailsDrawer, setShowRecordDetailsDrawer] = useState(false);
    const [selectedBatchRecord, setSelectedBatchRecord] = useState(false);
    const [filters, setFilters] = useState({
        record_status: undefined
    });


    const fetchBatchRecords = async (_pagination, _filters = filters) => {
        setIsTableLoading(true);
        // const response = await props.batch.fetch_records({ pageSize: _pagination.pageSize, current: _pagination.current, record_status: _filters.record_status, batch_type: props.batch.batch_type, submerchant_id: _filters.submerchant_id  });
        const response = await props.batch.fetch_records_v2({ pageSize: _pagination.pageSize, current: _pagination.current, record_status: _filters.record_status, batch_type: props.batch.batch_type });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        // let queryset = response.data.results;
        // queryset = queryset.map((batch) => { return { ...batch, is_submerchant:!!_filters.submerchant_id, submerchant: _filters.submerchant_id}})
        // setRecords(queryset);
        setRecords(response.data.results);
        setPagination({ ..._pagination, ...response.data.pagination });
        setIsTableLoading(false);
    };

    const exportBatch = async () => {
        setIsExporting(true);
        const response = await props.batch.export({ record_status: filters.record_status });
        if (!response) {
            setIsExporting(false);
            handleApiExceptions("Something went wrong !");
            return;
        }
        setIsExporting(false);
        FileSaver.saveAs(response.data, `${props.batch.name}.xlsx`);
    };

    const handleTableChange = (tableInfo) => {
        setPagination(tableInfo.pagination);
        fetchBatchRecords(tableInfo.pagination);
    };

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchBatchRecords({ ..._pagination }, filters);
    };

    const renderTitle = () => {
        return (
            <div className="mb-2 d-flex align-items-start">
                <div>
                    <Text1 className="d-block" strong>Batch Records</Text1>
                    <Text4>{props.batch.name}</Text4>
                </div>
                <div className="mt-1 ml-2">
                    <Select
                        allowClear
                        style={{ width: 200 }}
                        size="small"
                        placeholder="Filter by Record Status"
                        onChange={value => {
                            const _filters = { record_status: value };
                            setFilters(_filters)
                            fetchBatchRecords(pagination, _filters)
                        }}
                    >
                        <Select.Option key="0" value="pending"><Badge color="yellow" text={<Text4>Pending</Text4>} /></Select.Option>
                        <Select.Option key="1" value="processing"><Badge color="blue" text={<Text4>Processing</Text4>} /></Select.Option>
                        <Select.Option key="2" value="completed"><Badge color="green" text={<Text4>Completed</Text4>} /></Select.Option>
                        <Select.Option key="3" value="failed"><Badge color="red" text={<Text4>Failed</Text4>} /></Select.Option>
                        <Select.Option key="4" value="cancelled"><Badge color="grey" text={<Text4>Cancelled</Text4>} /></Select.Option>
                    </Select>
                </div>
            </div>
        )
    };

    const renderBatchInfo = () => {
        const records_status = props.batch.records_status || [];
        return (
            <div className="row" style={{ width: "90%" }}>
                <div className="col-sm"><Badge color="yellow" /><Text4 strong>Pending: </Text4><Text4>{records_status.find(s => s.status == "pending") && records_status.find(s => s.status == "pending").total || 0}</Text4></div>
                <div className="col-sm"><Badge color="blue" /><Text4 strong>Processing: </Text4><Text4>{records_status.find(s => s.status == "processing") && records_status.find(s => s.status == "processing").total || 0}</Text4></div>
                <div className="col-sm"><Badge color="green" /><Text4 strong>Completed: </Text4><Text4>{records_status.find(s => s.status == "completed") && records_status.find(s => s.status == "completed").total || 0}</Text4></div>
                <div className="col-sm"><Badge color="red" /><Text4 strong>Failed: </Text4><Text4>{records_status.find(s => s.status == "failed") && records_status.find(s => s.status == "failed").total || 0}</Text4></div>
                <div className="col-sm"><Badge color="grey" /><Text4 strong>Cancelled: </Text4><Text4>{records_status.find(s => s.status == "cancelled") && records_status.find(s => s.status == "cancelled").total || 0}</Text4></div>
            </div>
        )
    };

    const renderButtons = () => {
        return (
            <div className="d-flex justify-content-end">
                <Tooltip title="Refresh" className="mr-1">
                    <Button
                        icon="sync"
                        onClick={() => props.fetchBulkUploads()}
                    />
                </Tooltip>
                <Tooltip title={`${props.batch.status != "completed" ? "Batch not completed yet." : "Export"}`}>
                    <PermissableButton
                        type="primary"
                        disabled={!records.length || props.batch.status != "completed"}
                        icon="download"
                        loading={isExporting}
                        onClick={exportBatch}
                    />
                </Tooltip>
            </div>
        )
    };

    const toggleRecordDetailsDrawer = (record = {}) => {
        setSelectedBatchRecord(record);
        setShowRecordDetailsDrawer(!showRecordDetailsDrawer);
    };

    const tableColumns = getRecordsTableColumns(props.batch.batch_type, { toggleRecordDetailsDrawer: toggleRecordDetailsDrawer });

    useEffect(() => {
        if (props.batch && props.batch.uuid) {
            fetchBatchRecords(pagination);
            // fetchBatchRecords(pagination, {...filters, submerchant_id: records.submerchant});
        }
    }, [props.batch]);

    return (
        <EaseDrawer
            title={false}
            width={850}
            visible={props.visible}
            onClose={() => {
                let _filters = { record_status: undefined };
                setFilters(_filters);
                props.toggleRecordsDrawer()
            }}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                {renderTitle()}
                <div className="d-flex justify-content-between align-items-center">
                    {renderBatchInfo()}
                    {renderButtons()}
                </div>
                <EaseTable
                    rowKey="id"
                    loading={props.isTableLoading || isTableLoading}
                    data={records}
                    columns={tableColumns}
                    pagination={pagination}
                    handleTableChange={handleTableChange}
                    totalRecords={pagination.total}
                    fixedSelectable={!isMobile}
                /><PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
                <RecordDetailsDrawer
                    visible={showRecordDetailsDrawer}
                    toggleRecordDetailsDrawer={toggleRecordDetailsDrawer}
                    batch_record={selectedBatchRecord}
                    threshold_percentage={props.threshold_percentage}
                />
            </div>
        </EaseDrawer>
    )
};

export { RecordsDrawer };